export const CLEAN_REGISTRATION_DATA = 'CLEAN_REGISTRATION_DATA';
export const CHANGE_COMPANY_REGISTRATION_DATA = 'CHANGE_COMPANY_REGISTRATION_DATA';
export const CHANGE_REGISTRATION_CURRENT_STEP = 'CHANGE_REGISTRATION_CURRENT_STEP';
export const CHANGE_REGISTRATION_FILLED_STEPS_COUNT = 'CHANGE_REGISTRATION_FILLED_STEPS_COUNT';
export const CHANGE_REGISTRATION_VISITED_STEPS_COUNT = 'CHANGE_REGISTRATION_VISITED_STEPS_COUNT';

export const CHANGE_REGISTRATION_RECAPTCHA_TOKEN = 'CHANGE_REGISTRATION_RECAPTCHA_TOKEN';

export const CHANGE_CLIENT_REGISTRATION_DATA = 'CHANGE_CLIENT_REGISTRATION_DATA';

export const LOAD_INDUSTRIES = 'LOAD_INDUSTRIES';
export const LOAD_REGULATIONS = 'LOAD_REGULATIONS';
export const LOAD_OFFICE_LOCATIONS = 'LOAD_OFFICE_LOCATIONS';
export const LOAD_AMOUNT_OF_EMPLOYEES = 'LOAD_AMOUNT_OF_EMPLOYEES';
export const LOAD_CYBERSECURITY_KNOWHOW_OPTIONS = 'LOAD_CYBERSECURITY_KNOWHOW_OPTIONS';

export const LOAD_COMPANY_SUGGESTIONS = 'LOAD_COMPANY_SUGGESTIONS';

export const LOAD_USER_REGISTRATION_INFO = 'LOAD_USER_REGISTRATION_INFO';
export const LOAD_COMPANY_REGISTRATION_INFO = 'LOAD_COMPANY_REGISTRATION_INFO';

export const REGISTER_USER = 'REGISTER_USER';
export const REGISTRATION_FINISHED = 'REGISTRATION_FINISHED';

export const REQUEST_EMAIL_VERIFICATION = 'REQUEST_EMAIL_VERIFICATION';
export const VERIFY_EMAIL = 'VERIFY_EMAIL';

export const CHANGE_CLIENT_AVATAR = 'CHANGE_CLIENT_AVATAR';

export const CHANGE_WORKSPACE_ID = 'CHANGE_WORKSPACE_ID';

export const SET_IS_USER_POOL_EXISTS = 'SET_IS_USER_POOL_EXISTS';
export const CHECK_IF_USER_POOL_EXISTS = 'CHECK_IF_USER_POOL_EXISTS';
export const GET_COMPANY_INFO = 'GET_COMPANY_INFO';

export const CLEAN_INVITATION_CODE_DATA = 'CLEAN_INVITATION_CODE_DATA';
export const VALIDATE_INVITATION_CODE = 'VALIDATE_INVITATION_CODE';
export const UPDATE_RECAPTCHA_FOR_INVITATION_CODE = 'UPDATE_RECAPTCHA_FOR_INVITATION_CODE';
export const CHANGE_WHITE_LABELING_INFO = 'CHANGE_WHITE_LABELING_INFO';
export const SET_REGISTRATION_USER_EMAIL = 'SET_REGISTRATION_USER_EMAIL';
export const CLEAN_REGISTRATION_USER_EMAIL = 'CLEAN_REGISTRATION_USER_EMAIL';
